






































import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'

import { latLng } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet';
import { googleMaps, openStreetMap } from './MapProvider'
import { Widget } from '../base';

import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  components: {
    LIcon,
    LMap,
    LMarker,
    LTileLayer,
    NoWidgetAccess,
  },
  props: {
    widget: {
      type: Object as PropType<Widget>,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      currentZoom: 10,
      currentCenter: latLng(0, 0),
      mapOptions: {
        zoomSnap: 0.5
      },
      iconBaseSize: 48,
    }
  },
  computed: {
    ...mapGetters(['getCurrentAlarmId']),
    currentAlarm() {
      return this.$store.state.alarm.items[this.getCurrentAlarmId] || null
    },
    centerSelection() {
      return this.widget?.customSettings.settings?.centerPoint.value
    },
    centerCluster() {
      return { lat: this.$store.state.cluster.address.lat, lng: this.$store.state.cluster.address.lng }
    },
    centerAlarm() {
      return { lat: this.currentAlarm?.lat, lng: this.currentAlarm?.lng }
    },
    centerPoint() {
      if (this.centerSelection === 'alarm' && this.currentAlarm) {
        return this.centerAlarm
      }

      if (this.centerSelection === 'cluster-alarm' && this.currentAlarm) {
        return {
          lat: (this.$store.state.cluster.address.lat + this.currentAlarm?.lat) / 2,
          lng: (this.$store.state.cluster.address.lng + this.currentAlarm?.lng) / 2
        }
      }

      return this.centerCluster
    },
    zoomLevel() {
      return this.widget?.customSettings.settings?.zoomLevel.value
    },
    currentMap() {
      const selectedMapProvider = this.widget?.customSettings.settings?.map.data.mapProvider
      const selectedMapType = this.widget?.customSettings.settings?.map.data.mapType

      let mapData = {}

      switch (selectedMapProvider) {
        case 'googleMaps':
          mapData = googleMaps
          break;
        default:
          mapData = openStreetMap
      }

      return {
        attrib: mapData[selectedMapType].attrib,
        layer: mapData[selectedMapType].layer
      }
    }

  },
  methods: {
    zoomUpdate(zoom: number) {
      this.currentZoom = zoom
    },
    centerUpdate(center: string) {
      this.currentCenter = center
    }
  },
  mounted() {
    // Workaround for rendering issue of map
    // https://github.com/vue-leaflet/Vue2Leaflet/issues/96#issuecomment-341459943
    setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 250);
  }
})
